module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-nprogress@5.14.0_gatsby@5.14.6_react-dom@18.3.1_react@18.3.1__react@18.3._c0c6f1958f71cc9f4298d5f995d56c90/node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.14.6_react-dom@18.3.1_react@18.3.1__react@18.3.1_type-fest@2.19.0_typescript@5.9.2/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
